document.addEventListener("DOMContentLoaded", () => {
  const bannerInstances = document.querySelectorAll('.unified-banner-v1');

  bannerInstances.forEach(banner => {
    const video = banner.querySelector('video');
    const videoPlayButton = banner.querySelector('.video-button');

    if (video && videoPlayButton) {
      video.addEventListener('play', function() {
        videoPlayButton.removeAttribute("paused");
      });

      video.addEventListener('pause', function() {
        videoPlayButton.setAttribute("paused", "paused");
      });

      videoPlayButton.addEventListener("click", function() {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  });
});
